import { TopNav } from "../components/TopNav";
import { Sparkles, ChromeIcon } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopNav />
      <main className="pt-32 px-5 grid place-items-center min-h-[100svh]">
        <div className="w-full max-w-md glass-strong rounded-3xl p-8 relative overflow-hidden">
          <div className="absolute -top-32 -left-16 h-[300px] w-[300px] rounded-full bg-[#FE0979]/15 blur-3xl" />
          <div className="absolute -bottom-32 -right-16 h-[300px] w-[300px] rounded-full bg-[#00F2FE]/12 blur-3xl" />
          <div className="relative">
            <span className="inline-flex items-center gap-2 glass rounded-full px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-200">
              <Sparkles className="h-3 w-3 text-[#00F2FE]" /> Save your trips
            </span>
            <h1 className="mt-4 font-display font-black text-3xl sm:text-4xl tracking-tight">Sign in to <span className="text-gradient">VYBE</span></h1>
            <p className="mt-2 text-sm text-zinc-400">Save itineraries, sync across devices, and get a feed of viral trips for your taste.</p>

            <button
              onClick={handleGoogle}
              data-testid="google-login-btn"
              className="mt-7 w-full inline-flex items-center justify-center gap-3 bg-white text-black font-display font-bold uppercase tracking-[0.18em] text-xs rounded-full px-5 py-3.5 hover:bg-zinc-100 active:scale-[0.98] transition"
            >
              <ChromeIcon className="h-4 w-4" /> Continue with Google
            </button>
            <p className="mt-4 text-[11px] text-zinc-500 text-center">By continuing you agree to be cool to other creators.</p>
          </div>
        </div>
      </main>
    </div>
  );
}
